import { graphql } from 'react-relay';

export const upgradeEditionButtonFragmentSpec = graphql`
	fragment UpgradeEditionButtonFragment on ConfluenceTenantContext {
		editions {
			confluence
			__typename
		}
		__typename
	}
`;
